// ICONS
import ICON_SHEET from 'assets/img/check-list.png'
import ICON_FINISHED from 'assets/img/fabric.png'
import ICON_HOME from 'assets/img/home.png'
import ICON_MAINTENANCE from 'assets/img/maintenance.png'
import ICON_PREVENTIVE from 'assets/img/medical-insurance.png'
import ICON_MONITORING from 'assets/img/monitoringTrainingPlan.svg'
import ICON_NC from 'assets/img/nc.png'
import ICON_USER from 'assets/img/people (1).png'
import ICON_CUSTOMER from 'assets/img/people.png'
import ICON_RRHH from 'assets/img/rrhh.png'
import ICON_SUGGESTION from 'assets/img/suggestion.svg'
import ICON_TRAINING_PLAN from 'assets/img/trainingPlan.svg'
import ICON_WORKER from 'assets/img/treballadors.svg'
import ICON_WEAVING from 'assets/img/weaving.png'

export const MenuOficina = [
  {
    title: 'Panell',
    slug: '/',
    active: true,
    icon: ICON_HOME,
    requiredPermissions: null
  },
  {
    title: 'Acabats',
    slug: '',
    active: false,
    icon: ICON_FINISHED,
    requiredPermissions: null,
    subMenu: [
      {
        title: 'Fitxa Tècnica',
        slug: '/ft-acabats',
        active: true,
        icon: ICON_SHEET,
        requiredPermissions: null
      },
      {
        title: 'Preventiu',
        slug: '/prevenacabats',
        active: true,
        icon: ICON_PREVENTIVE,
        requiredPermissions: null
      },
      {
        title: 'Manteniment',
        slug: '/mantothers',
        active: true,
        icon: ICON_MAINTENANCE,
        requiredPermissions: null
      }
    ]
  },
  {
    title: 'Teixiduria',
    slug: '',
    active: false,
    icon: ICON_WEAVING,
    requiredPermissions: null,
    subMenu: [
      {
        title: 'Fitxa Tècnica',
        slug: '/ft-teixiduria',
        active: true,
        icon: ICON_SHEET,
        requiredPermissions: null
      },
      {
        title: 'Proto',
        slug: '/ft-proto-teixiduria',
        active: true,
        icon: ICON_SHEET,
        requiredPermissions: null
      },
      {
        title: 'Preventiu',
        slug: '/preventeix',
        active: true,
        icon: ICON_PREVENTIVE,
        requiredPermissions: null
      },
      {
        title: 'Manteniment',
        slug: '/mantteix',
        active: true,
        icon: ICON_MAINTENANCE,
        requiredPermissions: null
      }
    ]
  },
  {
    title: 'NC',
    slug: '',
    active: false,
    icon: ICON_NC,
    requiredPermissions: null,
    subMenu: [
      {
        title: 'Fitxa',
        slug: '/no-conformitats',
        active: true,
        icon: ICON_SHEET,
        requiredPermissions: null
      }
    ]
  },
  {
    title: 'RRHH',
    slug: '',
    active: false,
    icon: ICON_RRHH,
    requiredPermissions: null,
    subMenu: [
      {
        title: 'Suggeriment',
        slug: '/sugerencia',
        active: true,
        icon: ICON_SUGGESTION,
        requiredPermissions: null
      },
      {
        title: 'Pla Formació',
        slug: '/pla-formacio',
        active: true,
        icon: ICON_TRAINING_PLAN,
        requiredPermissions: ['HumanResourcesFullPermission']
      },
      {
        title: 'Seguiment',
        slug: '/seguiment-formacio',
        active: true,
        icon: ICON_MONITORING,
        requiredPermissions: ['HumanResourcesFullPermission']
      },
      {
        title: 'Lloc Treball',
        slug: '/lloc-treball',
        active: true,
        icon: ICON_SHEET,
        requiredPermissions: ['HumanResourcesFullPermission']
      },
      {
        title: 'Treballador',
        slug: '/treballadors',
        active: true,
        icon: ICON_WORKER,
        requiredPermissions: ['HumanResourcesFullPermission']
      },
      {
        title: 'Polivalència',
        slug: '/polivalencies',
        active: true,
        icon: ICON_SHEET,
        requiredPermissions: ['HumanResourcesFullPermission']
      }
    ]
  },
  {
    title: 'Control',
    slug: '',
    active: false,
    icon: ICON_SHEET,
    requiredPermissions: null,
    subMenu: [
      {
        title: 'Control Visió',
        slug: '/visioncontrol',
        active: true,
        icon: ICON_SHEET,
        requiredPermissions: null
      },
      {
        title: 'Checklist (RAM)',
        slug: '/checklist',
        active: true,
        icon: ICON_SHEET,
        requiredPermissions: null
      },
      {
        title: 'Checklist (MAQ)',
        slug: '/checklistmaq',
        active: true,
        icon: ICON_SHEET,
        requiredPermissions: null
      }
    ]
  },
  {
    title: 'Usuaris',
    slug: '/usuaris',
    active: false,
    icon: ICON_USER,
    requiredPermissions: ['UsersFullPermission']
  },
  {
    title: 'Clients',
    slug: '/clients',
    active: true,
    icon: ICON_CUSTOMER,
    requiredPermissions: null
  },
  {
    title: 'Inventari',
    slug: '/inventari',
    active: true,
    icon: ICON_SHEET,
    requiredPermissions: null
  }
]
